(() => {
  const body = document.body;
  const header = document.querySelector('[data-bdc-header]');
  const megaToggle = document.querySelector('[data-bdc-mega-toggle]');
  const megaPanel = document.querySelector('[data-bdc-mega-panel]');
  const searchToggle = document.querySelector('[data-bdc-search-toggle]');
  const searchPanel = document.querySelector('[data-bdc-search-panel]');
  const searchClose = document.querySelector('[data-bdc-search-close]');
  const mobileOpen = document.querySelector('[data-bdc-mobile-open]');
  const mobileClose = document.querySelector('[data-bdc-mobile-close]');
  const mobileDrawer = document.querySelector('[data-bdc-mobile-drawer]');
  const overlay = document.querySelector('[data-bdc-overlay]');

  const setOverlay = (on) => overlay?.classList.toggle('is-visible', on);

  const setMega = (open) => {
    if (!megaPanel || !megaToggle) return;
    megaPanel.classList.toggle('is-open', open);
    megaPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    header?.classList.toggle('is-mega-open', open);
    setOverlay(open || mobileDrawer?.classList.contains('is-open'));
  };

  const setSearch = (open) => {
    if (!searchPanel || !searchToggle) return;
    searchPanel.classList.toggle('is-open', open);
    searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    header?.classList.toggle('is-search-open', open);
    if (open) {
      setMega(false);
      requestAnimationFrame(() => searchPanel.querySelector('input[type="search"]')?.focus());
    }
  };

  const setMobile = (open) => {
    if (!mobileDrawer || !mobileOpen) return;
    mobileDrawer.classList.toggle('is-open', open);
    mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    mobileOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('is-menu-open', open);
    if (open) {
      setMega(false);
      setSearch(false);
    }
    setOverlay(open || megaPanel?.classList.contains('is-open'));
  };

  megaToggle?.addEventListener('click', () => setMega(!megaPanel?.classList.contains('is-open')));
  searchToggle?.addEventListener('click', () => setSearch(!searchPanel?.classList.contains('is-open')));
  searchClose?.addEventListener('click', () => setSearch(false));
  mobileOpen?.addEventListener('click', () => setMobile(true));
  mobileClose?.addEventListener('click', () => setMobile(false));
  overlay?.addEventListener('click', () => { setMega(false); setSearch(false); setMobile(false); });
  mobileDrawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMobile(false)));
  document.querySelectorAll('[data-bdc-mega-open]').forEach((button) => button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.setTimeout(() => setMega(true), 320);
  }));

  /* Desktop mega menu tabs */
  const megaTabs = [...document.querySelectorAll('[data-bdc-mega-tab]')];
  const megaTabPanels = [...document.querySelectorAll('[data-bdc-mega-panel-index]')];
  const activateMegaTab = (index) => {
    megaTabs.forEach((tab) => {
      const active = tab.dataset.bdcMegaTab === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    megaTabPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.bdcMegaPanelIndex === String(index)));
  };
  megaTabs.forEach((tab) => {
    tab.addEventListener('mouseenter', () => activateMegaTab(tab.dataset.bdcMegaTab));
    tab.addEventListener('click', () => activateMegaTab(tab.dataset.bdcMegaTab));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMega(false);
      setSearch(false);
      setMobile(false);
      closeLightbox();
    }
  });

  document.addEventListener('click', (event) => {
    if (!header?.contains(event.target) && megaPanel?.classList.contains('is-open')) setMega(false);
  });

  document.querySelectorAll('.bdc-products, [data-bdc-home-products]').forEach((section) => {
    const rail = section.querySelector('[data-bdc-product-rail]');
    const prev = section.querySelector('[data-bdc-rail-prev]');
    const next = section.querySelector('[data-bdc-rail-next]');
    if (!rail) return;
    const amount = () => Math.max(rail.clientWidth * 0.78, 320);
    prev?.addEventListener('click', () => rail.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-bdc-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.closest('form')?.submit());
  });

  /* Product detail gallery */
  const productRoot = document.querySelector('[data-bdc-product-root]');
  if (productRoot) {
    const mainImage = productRoot.querySelector('.bdc-product-main-image');
    const thumbs = [...productRoot.querySelectorAll('[data-bdc-thumb]')];
    const select = productRoot.querySelector('[data-bdc-variant-select]');
    const priceNode = productRoot.querySelector('[data-bdc-product-price]');
    const compareNode = productRoot.querySelector('[data-bdc-product-compare]');
    const saleNode = productRoot.querySelector('[data-bdc-product-sale]');
    const statusNode = productRoot.querySelector('[data-bdc-product-status]');
    const addButton = productRoot.querySelector('[data-bdc-add-button]');
    const stickyBuy = document.querySelector('[data-bdc-sticky-buy]');
    const stickyPrice = document.querySelector('[data-bdc-sticky-price]');
    const stickyAdd = document.querySelector('[data-bdc-sticky-add]');
    const buyRow = productRoot.querySelector('.bdc-product-buy-row');

    const switchImage = (thumb) => {
      if (!thumb || !mainImage) return;
      mainImage.classList.add('is-switching');
      const src = thumb.dataset.imageSrc;
      const srcset = thumb.dataset.imageSrcset;
      const alt = thumb.dataset.imageAlt || '';
      window.setTimeout(() => {
        if (src) mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        mainImage.alt = alt;
        mainImage.classList.remove('is-switching');
      }, 90);
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => switchImage(thumb)));

    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (option.dataset.price && priceNode) priceNode.textContent = option.dataset.price;
      if (option.dataset.price && stickyPrice) stickyPrice.textContent = option.dataset.price;
      const compare = option.dataset.compare || '';
      if (compareNode) {
        compareNode.textContent = compare;
        compareNode.classList.toggle('is-hidden', !compare);
      }
      saleNode?.classList.toggle('is-hidden', !compare);
      const available = option.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Kosárba teszem' : 'Elfogyott';
      }
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? 'Kosárba teszem' : 'Elfogyott';
      }
      if (statusNode) {
        statusNode.classList.toggle('is-soldout', !available);
        statusNode.innerHTML = available
          ? '<span></span><div class="bdc-product-status__copy"><strong>Elérhetőség ellenőrzéssel</strong><small>A rendelést készletellenőrzés után igazoljuk vissza.</small></div>'
          : '<span></span><div class="bdc-product-status__copy"><strong>Jelenleg nem rendelhető</strong><small>Ez a változat most nem érhető el.</small></div>';
      }
      const mediaId = option.dataset.mediaId;
      if (mediaId) {
        const matchedThumb = thumbs.find((thumb) => thumb.dataset.mediaId === mediaId);
        if (matchedThumb) switchImage(matchedThumb);
      }
    });

    const qty = productRoot.querySelector('[data-bdc-quantity] input');
    productRoot.querySelector('[data-bdc-qty-minus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(Number(qty.min || 1), Number(qty.value || 1) - 1);
    });
    productRoot.querySelector('[data-bdc-qty-plus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Number(qty.value || 1) + 1;
    });

    stickyAdd?.addEventListener('click', () => {
      if (!addButton || addButton.disabled) return;
      addButton.click();
    });

    if (stickyBuy && buyRow && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const showSticky = !entry.isIntersecting && window.matchMedia('(max-width: 560px)').matches;
        stickyBuy.classList.toggle('is-visible', showSticky);
        stickyBuy.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
      }, { threshold: 0.15 });
      stickyObserver.observe(buyRow);
      window.addEventListener('resize', () => {
        if (!window.matchMedia('(max-width: 560px)').matches) {
          stickyBuy.classList.remove('is-visible');
          stickyBuy.setAttribute('aria-hidden', 'true');
        }
      });
    }
  }

  /* Image lightbox */
  const lightbox = document.querySelector('[data-bdc-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-bdc-lightbox-image]');
  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-menu-open');
  };
  document.querySelector('[data-bdc-zoom-open]')?.addEventListener('click', () => {
    const image = document.querySelector('.bdc-product-main-image');
    if (!lightbox || !lightboxImage || !image) return;
    lightboxImage.src = image.currentSrc || image.src;
    lightboxImage.alt = image.alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    body.classList.add('is-menu-open');
  });
  document.querySelector('[data-bdc-zoom-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
})();

/* V31: app-free curated bathroom bundles */
(() => {
  const roots = [...document.querySelectorAll('[data-bdc-bundles-root]')];
  if (!roots.length) return;

  const money = (centsOrForints) => {
    const value = Number(centsOrForints || 0);
    return new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0 }).format(value) + ' Ft';
  };

  const esc = (value = '') => String(value).replace(/[&<>'"]/g, (ch) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
  const normalize = (value = '') => String(value).trim().toLocaleLowerCase('hu-HU').replace(/\s+/g, '');

  let toast = document.querySelector('.bdc-bundle-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'bdc-bundle-toast';
    document.body.appendChild(toast);
  }
  let toastTimer;
  const showToast = (message) => {
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  };

  const modal = document.querySelector('[data-bdc-bundle-modal]');
  const modalContent = modal?.querySelector('[data-bdc-bundle-modal-content]');
  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bdc-bundle-modal-open');
  };
  modal?.querySelectorAll('[data-bdc-bundle-close]').forEach((btn) => btn.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal?.classList.contains('is-open')) closeModal(); });

  const bundleMap = new Map();
  // V48: Confirm actual storefront availability, independently of Shopify collection membership.
  // Draft, unpublished and sold-out bundle products stay unavailable.
  const liveAvailabilityRequests = new Map();
  const verifyLiveBundle = (bundle) => {
    if (!liveAvailabilityRequests.has(bundle.handle)) {
      const promise = fetch(`/products/${encodeURIComponent(bundle.handle)}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then(async response => {
        if (!response.ok) return false;
        const product = await response.json();
        return product.available === true && (product.variants || []).some(v => v.available === true);
      }).catch(() => false);
      liveAvailabilityRequests.set(bundle.handle, promise);
    }
    return liveAvailabilityRequests.get(bundle.handle);
  };

  const composition = (bundle, context = 'card') => {
    const items = bundle.components.slice(0, 4);
    const layoutClass = items.length === 2 ? 'is-two' : items.length === 3 ? 'is-three' : 'is-four';
    return `
      <div class="bdc-bundle-gridmedia bdc-bundle-gridmedia--${context} ${layoutClass}" aria-label="${esc(bundle.name)} termékei">
        ${items.map((item, index) => `
          <a class="bdc-bundle-gridmedia__item bdc-bundle-gridmedia__item--${index + 1}" href="/products/${encodeURIComponent(item.handle)}" aria-label="${esc(item.title)} megnyitása">
            <img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">
            <span>${index + 1}</span>
          </a>`).join('')}
      </div>`;
  };

  const bundleSubtitle = (bundle) => bundle.type === 'Mosdószett'
    ? `${bundle.finish} mosdókagyló és hozzá illő magasított csaptelep`
    : `${bundle.finish} zuhanyrendszer és hozzá illő kabin vagy zuhanyfal`;

  const card = (bundle) => `
    <article class="bdc-curated-bundle bdc-curated-bundle--v36 ${bundle.shopify_available ? '' : 'bdc-curated-bundle--unavailable'}">
      <div class="bdc-curated-bundle__media">
        ${composition(bundle, 'card')}
        <div class="bdc-curated-bundle__discount-float">${bundle.shopify_available ? '−5 990 Ft' : 'Készletellenőrzés alatt'}</div>
      </div>
      <div class="bdc-curated-bundle__body">
        <div class="bdc-curated-bundle__meta"><span>${esc(bundle.finish)}</span><span>${esc(bundle.type)} · ${bundle.components.length} termék</span></div>
        <h3>${esc(bundle.name)}</h3>
        <p class="bdc-curated-bundle__subtitle">${esc(bundleSubtitle(bundle))}</p>
        <div class="bdc-curated-bundle__offer">
          <div class="bdc-curated-bundle__price-stack">
            <del>${money(bundle.actual_total)}</del>
            <strong>${money(bundle.bundle_price)}</strong>
          </div>
          <span class="bdc-curated-bundle__saving">5 990 Ft megtakarítás</span>
        </div>
        <button class="bdc-curated-bundle__open bdc-curated-bundle__open--v36" type="button" data-bdc-bundle-open="${esc(bundle.handle)}">
          <span>Szett részletei</span><b>→</b>
        </button>
      </div>
    </article>`;

  roots.forEach((root) => {
    const dataNode = root.querySelector('[data-bdc-bundle-data]');
    const grid = root.querySelector('[data-bdc-bundle-grid]');
    if (!dataNode || !grid) return;
    let bundles = [];
    try { bundles = JSON.parse(dataNode.textContent || '[]'); } catch (err) { console.error('Bundle JSON error', err); return; }
    const stockNode = root.querySelector('[data-bdc-bundle-availability]');
    let stock = {};
    try { stock = JSON.parse(stockNode?.textContent || '{}'); } catch (err) { console.error('Bundle availability error', err); }
    // Stock truth comes from real Shopify bundle products. Missing/unpublished = unavailable.
    bundles.forEach((b) => {
      b.shopify_available = stock[b.handle] === true;
      bundleMap.set(b.handle, b);
    });
    const mode = root.dataset.mode || 'all';
    // V47: A három kiemelt új szett előnézete a főoldalon is látszódjon
    // akkor is, amikor az import még Draft/0 készletes. Vásárlást továbbra
    // is kizárólag a Shopify által elérhetőnek jelzett szett enged.
    const shown = mode === 'featured'
      ? [...bundles.filter((b) => b.homepage_featured), ...bundles.filter((b) => !b.homepage_featured)].slice(0, 3)
      : bundles;
    grid.innerHTML = shown.map(card).join('');
    // Hydrate availability from each actual Shopify product page, not solely the collection.
    // On unpublished products Shopify returns a 404, so the card stays safely unavailable.
    shown.forEach((bundle, index) => {
      verifyLiveBundle(bundle).then(available => {
        bundle.shopify_available = available;
        const article = grid.querySelectorAll('.bdc-curated-bundle')[index];
        if (!article) return;
        article.classList.toggle('bdc-curated-bundle--unavailable', !available);
        const flag = article.querySelector('.bdc-curated-bundle__discount-float');
        if (flag) flag.textContent = available ? '−5 990 Ft' : 'Készletellenőrzés alatt';
      });
    });
    const filters = root.querySelector('[data-bdc-bundle-filters]');
    if (filters) {
      const buttons = [...filters.querySelectorAll('[data-bdc-bundle-filter]')];
      const applyFilter = (which) => {
        buttons.forEach((button) => {
          const selected = button.dataset.bdcBundleFilter === which;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        grid.querySelectorAll('.bdc-curated-bundle').forEach((cardNode, idx) => {
          const current = shown[idx];
          cardNode.hidden = !!current && which !== 'all' && current.type !== which;
        });
      };
      buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.bdcBundleFilter)));
      applyFilter('all');
    }
    if (!shown.length) {
      root.style.display = 'none';
    }
  });

  const variantLabel = (component) => {
    if (!component.variant_selection?.length) return '';
    return component.variant_selection.map((x) => `${esc(x.name)}: ${esc(x.value)}`).join(' · ');
  };

  const openBundle = (bundle) => {
    if (!modal || !modalContent) return;
    const items = bundle.components.map((item) => `
      <article class="bdc-bundle-item bdc-bundle-item--v35">
        <a class="bdc-bundle-item__media" href="/products/${encodeURIComponent(item.handle)}"><img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy"></a>
        <div class="bdc-bundle-item__body">
          <div class="bdc-bundle-item__type">${esc(item.product_type || 'REA')}</div>
          <h4><a href="/products/${encodeURIComponent(item.handle)}">${esc(item.title)}</a></h4>
          ${variantLabel(item) ? `<small>${variantLabel(item)}</small>` : ''}
          <div class="bdc-bundle-item__bottom"><strong>${money(item.price)}</strong><a class="bdc-bundle-item__arrow" href="/products/${encodeURIComponent(item.handle)}" aria-label="Termék megnyitása">→</a></div>
        </div>
      </article>`).join('');

    modalContent.innerHTML = `
      <div class="bdc-bundle-detail">
        <div class="bdc-bundle-detail__hero">
          <div class="bdc-bundle-detail__hero-media">${composition(bundle, 'modal')}</div>
          <div class="bdc-bundle-detail__copy">
            <p class="bdc-kicker">${esc(bundle.type)} · ${esc(bundle.finish)}</p>
            <h2 id="BdcBundleModalTitle">${esc(bundle.name)}</h2>
            <p data-bdc-bundle-live-description>${esc(bundleSubtitle(bundle))}. A szett minden eleme külön is megnyitható. ${bundle.shopify_available ? 'Az összeállítás egyetlen termékként kosárba tehető.' : 'A vásárlás a beszerezhetőség ellenőrzése és a szett aktiválása után lesz elérhető.'}</p>
            <div class="bdc-bundle-detail__discount-pill">5 990 Ft szettkedvezmény</div>
            <div class="bdc-bundle-detail__total">
              <small>${bundle.components.length} termék együtt</small>
              <div><del>${money(bundle.actual_total)}</del><strong>${money(bundle.bundle_price)}</strong></div>
            </div>
            <div class="bdc-bundle-detail__actions">
              <button class="bdc-bundle-addall" type="button" data-bdc-bundle-addall="${esc(bundle.handle)}" ${bundle.shopify_available ? '' : 'disabled aria-disabled="true"'}>${bundle.shopify_available ? 'Szett kosárba' : 'Készletellenőrzés alatt'}</button>
              <button class="bdc-bundle-continue" type="button" data-bdc-bundle-close-local>Vissza a szettekhez</button>
            </div>
          </div>
        </div>
        <div class="bdc-bundle-detail__products">
          <div class="bdc-bundle-detail__products-title"><h3>A szett tartalma</h3><span>Minden termék külön is megnyitható</span></div>
          <div class="bdc-bundle-detail__list">${items}</div>
        </div>
      </div>`;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bdc-bundle-modal-open');
    modalContent.querySelector('[data-bdc-bundle-close-local]')?.addEventListener('click', closeModal);
    // Correct the CTA as soon as the storefront confirms it can sell this exact bundle.
    verifyLiveBundle(bundle).then(available => {
      bundle.shopify_available = available;
      const button = modalContent.querySelector('[data-bdc-bundle-addall]');
      if (!button || button.dataset.bdcBundleAddall !== bundle.handle) return;
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.textContent = available ? 'Szett kosárba' : 'Készletellenőrzés alatt';
      const copy = modalContent.querySelector('[data-bdc-bundle-live-description]');
      if (copy) copy.textContent = `${bundleSubtitle(bundle)}. A szett minden eleme külön is megnyitható. ${available ? 'Az összeállítás egyetlen termékként kosárba tehető.' : 'A vásárlás a beszerezhetőség ellenőrzése és a szett aktiválása után lesz elérhető.'}`;
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-bdc-bundle-open]');
    if (!target) return;
    const bundle = bundleMap.get(target.dataset.bdcBundleOpen);
    if (bundle) openBundle(bundle);
  });

  const resolveVariant = async (component) => {
    const response = await fetch(`/products/${encodeURIComponent(component.handle)}.js`, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error(`Nem található: ${component.title}`);
    const product = await response.json();
    let candidates = (product.variants || []).filter((v) => v.available !== false);
    if (!candidates.length) candidates = product.variants || [];

    if (component.variant_selection?.length) {
      const optionNames = (product.options || []).map((o) => typeof o === 'string' ? o : (o.name || ''));
      const matched = candidates.find((variant) => component.variant_selection.every((selection) => {
        const idx = optionNames.findIndex((name) => normalize(name) === normalize(selection.name));
        if (idx < 0) return false;
        const val = Array.isArray(variant.options) ? variant.options[idx] : variant[`option${idx + 1}`];
        return normalize(val) === normalize(selection.value);
      }));
      if (matched) return matched;
    }
    return candidates[0];
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-bdc-bundle-addall]');
    if (!button) return;
    const bundle = bundleMap.get(button.dataset.bdcBundleAddall);
    if (!bundle) return;
    if (!bundle.shopify_available) {
      showToast('A szett jelenleg nem rendelhető. Az elemek külön megnyithatók.');
      return;
    }

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Szett hozzáadása…';

    try {
      const response = await fetch(`/products/${encodeURIComponent(bundle.handle)}.js`, {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        throw new Error('A szett termék még nincs importálva Shopifyba.');
      }

      const product = await response.json();
      const variant = (product.variants || []).find((v) => v.available === true);

      if (product.available === false || !variant?.id) {
        throw new Error('A szett jelenleg nem rendelhető.');
      }

      const componentNames = bundle.components.map((item) => item.title).join(' | ');

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1,
            properties: {
              '_Szett neve': bundle.name,
              '_Szett tartalma': componentNames
            }
          }]
        })
      });

      if (!addResponse.ok) {
        const body = await addResponse.json().catch(() => ({}));
        throw new Error(body.description || body.message || 'Nem sikerült a szettet a kosárba tenni.');
      }

      showToast(`Szett hozzáadva · ${money(bundle.bundle_price)}`);
      setTimeout(() => { window.location.href = '/cart'; }, 650);
    } catch (err) {
      console.error(err);
      showToast(err.message || 'Hiba történt a szett hozzáadásakor.');
      button.disabled = false;
      button.textContent = original;
    }
  });
})();

/* Autumn 2026 coupon copy: robust progressive enhancement. */
document.addEventListener('click', async function (event) {
  var trigger = event.target && event.target.closest ? event.target.closest('[data-av54-copy-code]') : null;
  if (!trigger) return;
  var code = trigger.getAttribute('data-av54-copy-code') || 'AUTUMN5';
  var original = trigger.getAttribute('data-original-label') || trigger.textContent;
  trigger.setAttribute('data-original-label', original);
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(code);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly','');
      ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta);
      ta.select(); var copied = document.execCommand('copy'); ta.remove();
      if (!copied) throw new Error('Copy unavailable');
    }
    trigger.textContent = 'Kimásolva ✓';
    trigger.setAttribute('aria-label','Kuponkód kimásolva');
  } catch(e) {
    trigger.textContent = 'Jelöld ki: ' + code;
  }
  setTimeout(function(){trigger.textContent=original;trigger.setAttribute('aria-label','Kuponkód másolása');},2200);
});
